<perfect-scrollbar [scrollIndicators]="false">
  <div class="help-content">
    <ng-content></ng-content>
  </div>
</perfect-scrollbar>
